import {
  USER_API_URL,
  USER_PROFILE_URL,
  TWO_SIDED_PUBLIC_DOMAIN,
  USStocksCategoryTypes,
  getPlatformType,
} from '../constants'
import { VYAPER_HOST } from './stocks/apiConstants'
import {
  getMfExtServiceUrl,
  getMfServiceUrl,
  getOldStrapiServiceUrl,
  getSEOServiceUrl,
  getStrapi4ServiceUrl,
  getUsStocksExtServiceUrl,
  getUsStocksServiceUrl,
  getGlobalSearchServiceUrl,
  getFDServiceUrl,
  getIndMemoryExtServiceUrl,
  getInsuranceServiceUrl,
  getPaymentsServiceUrl,
  getVyaparServiceUrl,
  getIndianStockBrokerUrl,
  getWidgetServiceUrl,
  getGoalsServiceUrl,
  getAccountAggregatorUrl,
  getOctopusServiceUrl,
  getShieldServiceUrl,
  getHyperVergeLoginUrl,
  getUsStocksBaseAuthUrl,
  getUsStocksExtAuthServiceUrl,
  getInsuranceServiceCoreUrl,
  getSubscriptionServiceUrl,
  getIndianStockCatalogUrl,
  getIndMoneyCoreAPI,
  getVyaparBackgroundOfficeUrls,
  getIndTrackServiceAPI,
  getSHIELD_URL,
  getMfTrackingServiceUrl,
} from './url-constants'
import { SLASH_OPERATOR } from '@/stories/strapi-4/utils/constants'
import { myUSStockPaginationLimit } from '@/components/USStocks/USStocksMyUSStocks/constants'

export const GATEWAY_HOST = 'https://apixt-iw.indmoney.com'

export const GATEWAY_HOST_IN = 'https://apixt-in.indmoney.com'

const indMoneyApiBaseUrl = getIndMoneyCoreAPI()
const indTrackApiBaseUrl = getIndTrackServiceAPI()
export const INSURANCE_CORE_BASE_URL = getInsuranceServiceCoreUrl()
export const SUBSCRIPTION_BASE_URL = getSubscriptionServiceUrl()
export const INDIAN_STOCK_CATALOG_URL = getIndianStockCatalogUrl()
export const MF_BASE_URL = getMfServiceUrl()
// const MF_BASE_PP_URL = 'https://mf-tracking-pp.indiawealth.in/public'
export const MF_TRACKING_BASE_URL = getMfTrackingServiceUrl()
const MF_EXT_BASE_URL = getMfExtServiceUrl()
const WIDGET_BASE_URL = getWidgetServiceUrl()
const GOALS_BASE_URL = getGoalsServiceUrl()
export const FD_BASE_URL = getFDServiceUrl()
export const ACCOUNT_AGGREGATOR_BASE_URL = getAccountAggregatorUrl()

export const US_STOCKS_BASE_AUTH_URL_EXT = getUsStocksExtAuthServiceUrl()

export const US_STOCKS_BASE_AUTH_URL = getUsStocksBaseAuthUrl()
export const US_STOCKS_BASE_URL_EXT = getUsStocksExtServiceUrl()
export const US_STOCKS_BASE_URL = getUsStocksServiceUrl()
export const SEO_SYSTEM_BASE_URL = getSEOServiceUrl()
export const GLOBAL_INDICES_BASE_URL = `${SEO_SYSTEM_BASE_URL}/web/v1/indices`

const SHIELD_BASE_URL = getShieldServiceUrl()
export const IND_MEMORY_EXT_BASE_URL = getIndMemoryExtServiceUrl()
export const IND_MEMORY_EXT_WEALTH_BASE_URL = getIndMemoryExtServiceUrl()
const INSURANCE_BASE_URL = getInsuranceServiceUrl()
export const OCTOPUS_BASE_URL =
  // 'octopus-pp.indiawealth.in'
  getOctopusServiceUrl()

export function getHelpCenterFAQs(topic_id?: string) {
  const baseUrl = `${TWO_SIDED_PUBLIC_DOMAIN}/v1/help-center/faq/topic-details/`
  const urlObj = new URL(baseUrl)

  urlObj.searchParams.set('topic_id', topic_id ?? '9')

  return urlObj.toString()
}

export const strapiBaseURL = getOldStrapiServiceUrl()
export const strapi4BaseURL = getStrapi4ServiceUrl()

export const strapi4FeaturesURL = (slug: string) =>
  `${strapi4BaseURL}/playgrounds/${slug}`

// export const strapi4BaseURL = 'http://10.0.14.59:1337/api'
// for dev
// export const strapiBaseURL = 'http://localhost:1337'
// export const strapi4BaseURL = 'http://127.0.0.1:1337/api'

// only works with vpn
// export const strapiBaseURL = 'https://strapi.indmoney.com'

// const MF_PRE_PROD_BASE_URL = 'https://mftrace-pre-prod.indiawealth.in/public'
// const MF_EXT_PRE_PROD_BASE_URL = 'https://mf-pp.indiawealth.in/api/public'

/** used for mock testing */
// export const strapiArticlesListingApiUrl = 'http://localhost:3000/articles'

export const globalSearchApiBaseUrl = getGlobalSearchServiceUrl()
export const apiSearchUrl = `${getGlobalSearchServiceUrl()}v1/global-search/`
export const apiSearchV2Url = `${getGlobalSearchServiceUrl()}/v3/global-search/?platform=web`
export const apiSearchV2DynamicUrl = `${getGlobalSearchServiceUrl()}/v3/global-search/dynamic/?platform=web`

// US Stocks api

export const getCategoryWiseUSStocksListAPIUrl = ({
  categoryFilters,
  page,
  limit = 8,
  includeData,
  categoryName,
}: {
  // https://steveholgado.com/typescript-types-from-arrays/
  categoryFilters: Array<USStocksCategoryTypes>
  page: number
  limit?: number
  includeData: boolean
  categoryName?: USStocksCategoryTypes
}) => {
  const US_STOCKS_CATEGORY_WISE_LIST_BASE_URL = `${US_STOCKS_BASE_AUTH_URL_EXT}/v3/user/foreign-stocks/bulkcategory`
  // make sure you have a '/' at the end of this URL, otherwise request fails for some weird reason
  const url = new URL(US_STOCKS_CATEGORY_WISE_LIST_BASE_URL)

  url.searchParams.append('category_filters', categoryFilters.join(','))
  url.searchParams.append('page', page.toString())
  url.searchParams.append('limit', limit.toString())

  if (includeData) {
    url.searchParams.append('include_data', '1')
  }

  if (categoryName === 'all') {
    url.searchParams.append('sort_order', 'desc')
    url.searchParams.append('sort_key', 'mcap')
  }

  const urlString = url.toString()
  return urlString
}

export const getCategoryWiseUSStocksListV1APIUrl = ({
  categoryFilters,
  page,
  limit = 8,
  includeData,
  categoryName,
}: {
  categoryFilters: Array<USStocksCategoryTypes>
  page: number
  limit?: number
  includeData: boolean
  categoryName?: USStocksCategoryTypes
}) => {
  const US_STOCKS_CATEGORY_WISE_LIST_BASE_URL = `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/user/foreign-stocks/stocks/category/bulk`
  const url = new URL(US_STOCKS_CATEGORY_WISE_LIST_BASE_URL)

  url.searchParams.append('category_filters', categoryFilters.join(','))
  url.searchParams.append('page', page.toString())
  url.searchParams.append('limit', limit.toString())

  if (includeData) {
    url.searchParams.append('include_data', '1')
  }

  if (categoryName === 'all') {
    url.searchParams.append('sort_order', 'desc')
    url.searchParams.append('sort_key', 'mcap')
  }

  const urlString = url.toString()
  return urlString
}

export const getUSStocksChartApiUrl = (
  symbol: string,
  startDate: string,
  endDate: string,
) =>
  `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/equity/foreign-stocks/ohlc/${symbol}?ignore_user_id=true&start=${startDate}&end=${endDate}&id_type=symbol&isweb=true`

export const apiForeignStockData = (
  symbol: string,
  initiator: 'server' | 'client' = 'server',
) => {
  const baseUrl =
    initiator === 'server'
      ? US_STOCKS_BASE_AUTH_URL
      : US_STOCKS_BASE_AUTH_URL_EXT

  return `${baseUrl}/v3/equity/foreign-stocks/${symbol}`
}

export const apiForeignStockPerformance = (symbol: string) =>
  `${indMoneyApiBaseUrl}/v3/equity/foreign-stocks/performance/?symbol=${symbol}`

export const apiGetForeignStocks = (ticker: string) =>
  `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/equity/foreign-stocks/infinityV2/all?limit=10&page=1&ticker=${ticker}&is_infinity=true`

export const apiEtfStockData = (
  symbol: string,
  timeline?: string | null,
): string => {
  const baseUrl = `${US_STOCKS_BASE_AUTH_URL_EXT}/v3/stocks/us-etf/${symbol}?is_static=true`
  const baseUrlObj = new URL(baseUrl)

  if (timeline) {
    baseUrlObj.searchParams.append('timeline', timeline)
  }

  const newRetVal = baseUrlObj.toString()

  return newRetVal
}

export const getCheckIfEtf = (symbol: string) =>
  `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/stocks/check-if-etf/${symbol.toUpperCase()}`

// MF api
export const apiGetMutualFunds = `${MF_BASE_URL}/v1/funds/catalogue/`
export const apiGetMutualFundsStaticData = `${MF_BASE_URL}/seo/v1/mf-page/static/`
export const apiGetTrendingMFData = `${MF_BASE_URL}/web/v1/trending/`

export const apiGetMfSEOL1Page = (slug: string) =>
  `${MF_BASE_URL}/seo/v1/collections/${slug}/static/`

export const apiPostMutualFundsListing = `${MF_BASE_URL}/v1/funds/search/`
export const apiMFlistingAccordionUrl = `${MF_BASE_URL}/v1/seo/widgets/l1-page?widget_name=search_nav`
export const apiMFFundCategoryURL = `${MF_BASE_URL}/v1/seo/widgets/l1-page?widget_name=category_intro`
export const apiGetMfInsightsL1Page = (slug: string) =>
  `${MF_BASE_URL}/v1/catalogue/trends/mf_categories?category_slug=${slug}`

export const apiPostUserMutualFundsListing = (memberId: number | null) =>
  `${MF_BASE_URL}/v1/user/funds/search/${
    memberId ? `?member_id=${memberId}` : ''
  }`

export const apiGetMutualFundsAllDetail = (schemeId: number) =>
  `${MF_BASE_URL}/web/v2/funds/${schemeId}/`

export const apiGetMFDetail = (schemeId: number) =>
  `${MF_TRACKING_BASE_URL}/public/v1/funds/${schemeId}/details/`

export const apiGetMutualFundsDetailInclude = (
  schemeId: number,
  memberId: number | null,
  widgetName?: string | null,
) =>
  `${MF_BASE_URL}/web/v2/funds/${schemeId}/${
    memberId ? `?member_id=${memberId}&` : '?'
  }widget_include=${widgetName}`

export const apiGetMutualFundsDetailExclude = (
  schemeId: number,
  memberId: number | null,
  widgetName?: string | null,
) =>
  `${MF_BASE_URL}/web/v2/funds/${schemeId}/${
    memberId ? `?member_id=${memberId}&` : '?'
  }widget_exclude=${widgetName}`

export const apiMFChartData = `${MF_BASE_URL}/v1/graph/`

export const apiGetMFCalculator = (
  schemeId: number,
  amount: number,
  investmentType: string,
  duration?: string,
) =>
  `${MF_BASE_URL}/v1/returns/compare/?id=${schemeId}&amount=${amount}&investment_type=${investmentType}${
    duration ? `&duration=${duration}` : ''
  }`

export const apiGetMFCalculatorL1 = (
  schemeId: string,
  amount: number,
  investmentType: string,
  duration?: string,
) =>
  `${MF_BASE_URL}/v1/calculators/fund/${schemeId}/returns?investment_type=${investmentType}&amount=${amount}${
    duration ? `&sip_freq=${duration}` : ''
  }`

export const apiGetDirRegCalculatorL1 = `${MF_BASE_URL}/v1/calculator/reg2dir/`
export const apiGetDirRegList = `${MF_BASE_URL}/v1/reg2dir/list`
export const apiGetSummaryDetailPage = `${MF_BASE_URL}/v2/users/transactions/sip-details`
export const apiGetSummaryDetailPageNew = `${MF_BASE_URL}/v1/users/transactions/sip-details`

//  MF Logged in APIs

export const apiGetAdvisoryRegToDirectFolio = ` ${MF_BASE_URL}/v1/mf-cards/reg-dir`

export const apiGetAdvisoryRegToDirect = (
  schemeId: number,
  memberId: number | null,
) =>
  `${MF_EXT_BASE_URL}/v1/switch-advisory/reg-to-dir/details${
    schemeId ? `?fund_id=${schemeId}` : ''
  }${memberId ? `&member_id=${memberId}` : ''}`

export const apiGetFolioModal = (params: string, memberId?: number | null) =>
  ` ${MF_BASE_URL}/v1/folios/${params ? `?${params}` : ''}${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const apiGetMyMutualFunds = (memberId: number | null) =>
  `${MF_BASE_URL}/v1/users/portfolio/funds${
    memberId ? `?member_id=${memberId}` : ''
  }`

export const apiGetMFMastheadCardPortfolio = (
  memberId: number | null,
  scope: string,
) => {
  let queryString = `?summary_scope=${scope}`
  if (memberId) {
    queryString += `&member_id=${memberId}`
  }
  return `${MF_BASE_URL}/v1/users/dashboard${queryString}`
}

export const apiGetMfActionCards = (memberId: number | null) =>
  `${MF_BASE_URL}/v2/mf-cards${memberId ? `?member_id=${memberId}` : ''}`

export const apiGetMFPerformanceSummary = (memberId: number | null) =>
  `${MF_BASE_URL}/v2/mfsummary/${memberId ? `?member_id=${memberId}` : ''}`

export const apiGetMFTransactions = (
  section: string,
  memberId: number | null,
) =>
  `${MF_BASE_URL}/v2/users/transactions?section=${section}&filter=ALL${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const apiGetMFDistributionSummary = (memberId: number | null) =>
  `${MF_BASE_URL}/v1/mf-distribution/${
    memberId ? `?member_id=${memberId}` : ''
  }`

export const apiGetMFTopHoldings = (memberId: number | null) =>
  `${MF_BASE_URL}/v1/mf-topHoldings/${memberId ? `?member_id=${memberId}` : ''}`

export const apiMFPortfolioOutdated = (memberId: number | null) =>
  `${MF_BASE_URL}/v1/refresh/portfolio/${
    memberId ? `?member_id=${memberId}` : ''
  }`

export const apiMFAddNominee1 = (memberId: number | null) =>
  `${MF_BASE_URL}/v1/add-nominee/${memberId ? `?member_id=${memberId}` : ''}`

export const apiMFDeclareNominee = (memberId: number | null) =>
  `${MF_BASE_URL}/v1/declare/nominee/${
    memberId ? `?member_id=${memberId}` : ''
  }`

export const apiMFaddNomineeinFunds = (memberId: number | null) =>
  `${MF_BASE_URL}/v1/users/portfolio/funds/nominee-required/${
    memberId ? `?member_id=${memberId}` : ''
  }`

export const apiMFaddNomineeSales = (memberId: number | null) =>
  `${MF_BASE_URL}/v1/users/portfolio/funds/nominee${
    memberId ? `?member_id=${memberId}` : ''
  }`

// MF Transaction APIs

export const apiGetInvestmentInfo = (memberId: number | null) =>
  `${MF_BASE_URL}/v2/funds/investment-info/${
    memberId ? `?member_id=${memberId}` : ''
  }`

export const apiGetRedeemTax = (
  fundId: string,
  folioId: string,
  units: number,
  memberId: number | null,
) =>
  `${MF_BASE_URL}/v1/funds/${fundId}/exitloadandtax?folio_id=${folioId}&units=${units}${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const apiGetRedeemInfo = (
  fundId: string,
  folioId: string,
  memberId: number | null,
) =>
  `${MF_BASE_URL}/v1/funds/${fundId}/redeem?folio_id=${folioId}${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const getDynNavLink = member_id =>
  `${MF_BASE_URL}/v1/users/nominee-flow/redirect${
    member_id ? `?member_id=${member_id}` : ''
  }`

export const apiGetBseOtpScreen = (memberId: number | null) =>
  `${MF_EXT_BASE_URL}/v1/txns/2fa_auth/${
    memberId ? `?member_id=${memberId}` : ''
  }`

export const apiGetSTPdetails = (
  folioId: string,
  from_fund_id: string,
  to_fund_id: string,
  memberId: number | null,
  frequency?: string,
) =>
  `${MF_EXT_BASE_URL}/v2/txns/power_stp/stp_fund_selection?flow_id=4&folio_no=${folioId}&from_fund_id=${from_fund_id}&to_fund_id=${to_fund_id}&source=normal_to_change${
    memberId ? `&member_id=${memberId}` : ''
  }${frequency ? `&frequency=${frequency}` : ''}`

export const apiGetSTPReview = (
  folioId: string,
  from_fund_id: string,
  to_fund_id: string,
  memberId: number | null,
  payload: {
    amount: number
    installments: number
    frequency: string
    start_date: string
    recurringAmount: number
  },
) =>
  `${MF_EXT_BASE_URL}/v1/txns/power_stp/normal_stp/review_order?recurring_amount=${
    payload.recurringAmount
  }
  &amount=${payload.amount}&no_of_transfer=${payload.installments}
  &start_date=${payload.start_date}&frequency=${
    payload.frequency
  }&folio_no=${folioId}
  &fund_id=${from_fund_id}&to_fund_id=${to_fund_id}&source=normal_to_change${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const getMF2FAPageConfigUrl = `${MF_EXT_BASE_URL}/v1/txns/2fa_page_config/`

export const apiGetSwitchOrderInfo = (memberId: number | null) =>
  `${MF_BASE_URL}/v1/switch-order/${memberId ? `?member_id=${memberId}` : ''}`

export const apiGetSwitchReview = ({
  folio_id,
  from_fund_id,
  to_fund_id,
  memberId,
  amount,
  order_type,
  installments,
  frequency,
  start_date,
  recurring_amount,
}: {
  folio_id: string
  from_fund_id: string
  to_fund_id: string
  memberId: number | null
  order_type: string
  amount: number
  start_date?: string
  frequency?: string
  installments?: number
  recurring_amount?: number
}) =>
  `${MF_BASE_URL}/v1/review-switch-order/?amount=${amount}&folio_id=${folio_id}&order_type=${order_type}&from_fund_id=${from_fund_id}&to_fund_id=${to_fund_id}${
    memberId ? `&member_id=${memberId}` : ''
  }${installments ? `&no_of_transfer=${installments}` : ''}${
    frequency ? `&frequency=${frequency}` : ''
  }${start_date ? `&start_date=${start_date}` : ''}${
    recurring_amount ? `&recurring_amount=${recurring_amount}` : ''
  }`

export const mfSelectedBankApiUrl = `${MF_BASE_URL}/v1/redeem/banks`

// MF Central Tracking APIs
export const apiGetMFCTWidgetBottomsheet = (
  orderId: string | number,
  memberId: number | string | null,
  flowType: string | null,
) =>
  `${MF_BASE_URL}/v1/ecas/redirection/?page=mfCentralTrackingStatus&orderId=${orderId}${
    flowType ? `&flowType=${flowType}` : ''
  }${memberId ? `&member_id=${memberId}` : ''}`

export const apiGetMFCTconfig = (
  memberId: number | string | null,
  flowType: string | null,
) =>
  `${MF_BASE_URL}/v1/ecas/input-config/${
    flowType ? `?flowType=${flowType}` : ''
  }${
    memberId
      ? flowType
        ? `&member_id=${memberId}`
        : `?member_id=${memberId}`
      : ''
  }`
export const apiGetMFTxnStatusconfig = `${MF_BASE_URL}/v1/users/transactions/details`
export const apiGetMFCTnextAction = `${MF_BASE_URL}/v1/ecas/next-action/`
export const apiGetMFCTOTPconfig = (
  orderId: string | number,
  flowType: string | null = null,
) =>
  `${MF_BASE_URL}/v1/ecas/otp-config/?orderId=${orderId}${
    flowType ? `&flowType=${flowType}` : ''
  }`

export const apiNomineeWidgetBottomsheet = (
  txn_id: string | number,
  memberId: number | string | null,
) =>
  `${MF_BASE_URL}/v1/invite-nominee/${txn_id ? `?txn_id=${txn_id}` : ''}${
    memberId ? `&member_id=${memberId}` : ''
  }`

// Transaction Center Apis

export const apiGetTransactionCenter = `${MF_EXT_BASE_URL}/v1/portfolio/transactions-details/`

// Dashboard Apis

export const getWidget = (widgetId: number, member_id: number | null) =>
  `${WIDGET_BASE_URL}/user/get-widget/?version=3.6.8&platform=WEB&isSmsSyncInProgress=0&widgetId=${widgetId}${
    member_id ? `&member_id=${member_id}` : ''
  }`

export const getAlerts = (member_id: number | null) =>
  `${indMoneyApiBaseUrl}/v1/communication/advisory/dynamo-cards/?card_type=ALERT&page=0&limit=10${
    member_id ? `&member_id=${member_id}` : ''
  }`

export const getGiftableRewards = (member_id: number | null) =>
  `${indMoneyApiBaseUrl}/v1/rewards_v2/dashboard/reward-cards/?page=0${
    member_id ? `&member_id=${member_id}` : ''
  }`

export const getUserGoals = (member_id: number | null) =>
  `${GOALS_BASE_URL}/api/v2/timeline/gamification/?dashboard=true${
    member_id ? `&memberId=${member_id}` : ''
  }`

export const getUserGoalsCoverage = (member_id: number | null) =>
  `${GOALS_BASE_URL}/api/v2/financial/goals-info${
    member_id ? `?memberId=${member_id}` : ''
  }`

export const getKycCards = (
  member_id: number | null,
  flowType = 'US_STOCKS_SBM',
) =>
  `${indMoneyApiBaseUrl}/v1/user/ivr-cards/?flowType=${flowType}${
    member_id ? `&memberId=${member_id}` : ''
  }&version=3.6.0`

// User Apis

export const userBasicApi = (member_id: number | null) =>
  `${USER_API_URL}${member_id ? `?member_id=${member_id}` : ''}`

export const userProfileApi = (member_id: number | null) =>
  `${USER_PROFILE_URL}${member_id ? `?member_id=${member_id}` : ''}`

export const checkPrimeUserApi = (member_id: number | null) =>
  `${indMoneyApiBaseUrl}/v2/freemium/checkprimeuser/${
    member_id ? `?member_id=${member_id}` : ''
  }`

export const getPrimeExpertAPi = (member_id: number | null) =>
  `${indMoneyApiBaseUrl}/v1/user-tracking/prime-expert/${
    member_id ? `?member_id=${member_id}` : ''
  }`

export const getUSStockDetailAPI = (ticker: string) => {
  return `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/equity/foreign-stocks/details_v2/${ticker.toUpperCase()}?isweb=true&ignore_user_id=true`
}

// ---------------  US STOCKS TRANSACTION APIS ---------------
export const getUSStockConfigAPIUrl = (
  ticker: string,
  transactionType: 'buy' | 'sell',
) => {
  const capTicker = ticker.toUpperCase()
  return `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/allowgeneric/users/symbol/config_v2/type/${transactionType}/${capTicker}`
}

export const getUSStockTransactionStatusPollingAPIUrl = (orderId: string) =>
  `${indMoneyApiBaseUrl}/v2/equity/dw-order/${orderId}/`

export const postBuySellUSStockAPIUrl = `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/stocks/dw/user/order/`

export const getShouldShowBuySellAPIUrl = (ticker: string) =>
  `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/usstocks/web/buy-sell/${ticker.toUpperCase()}`

export const getBuySellInfoApiUrl = (pageTitle: string) =>
  `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/getAcStatusScreen/?page_title=${pageTitle}`

export const getUSStockHoldingApiUrl = (ticker: string) =>
  `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/stocks/dw/user/account/holdings/${ticker.toUpperCase()}`

// --------------------- US STOCKS SIP APIS --------------------------
/** post api, payload example:
   * {
    "fund_detail": [
      {
        "amount": 0,		//default 0 for first time when user lands, mandatory from next refresh onwards
        "ticker": "COIN",
        sip_freq: Option[String]=None,
        sip_start_date: Option[String]=None,
        mandate_amt: Option[Int]=None
      }
    ]
  }
 */
export const usStocksSipRefreshAPIUrl = `${US_STOCKS_BASE_AUTH_URL_EXT}/v2/refreshSipPage`
export const getSipReturnsCalculator = ({
  ticker,
  year,
  sipAmount,
  frequency,
}: {
  ticker?: string
  year?: number
  sipAmount?: number
  frequency?: string
}) =>
  `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/sip/calculator/${ticker}?year=${year}&sip_amount=${sipAmount}&frequency=${frequency}`

export const getSipMandateApiUrl = ({
  sipId,
  method = 'GET',
}: {
  sipId?: string
  method?: 'GET' | 'POST'
}) => {
  const getBaseUrl = `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/getMandate`
  const postBaseUrl = `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/addMandate`
  const baseUrl = method === 'GET' ? getBaseUrl : postBaseUrl

  const urlObj = new URL(baseUrl)

  if (method === 'GET') {
    if (sipId) {
      // be aware of the case sensitive capital in query param 'SipId'
      urlObj.searchParams.append('SipId', sipId)
    }
  }

  return urlObj.toString()
}

// --------------------- US Stocks SIP APIs END --------------------------

export const usStocksTransactionsGetApiUrl = `${US_STOCKS_BASE_AUTH_URL_EXT}/v3/getTransactionsPageWidget`

// -------------- US Stocks TRANSACTION APIS END -------------------

export const strapiArticlesListingApiUrl = `${strapiBaseURL}/articles` as const

export const getCalculatorsChildApiUrl = (slug: string) =>
  `${strapiBaseURL}/calculators?slug=${slug}`

export const strapiArticlesCountApiUrl = `${strapiBaseURL}/articles/count`

export const strapiFilteredArticlesCountApiUrl = `${strapiBaseURL}/articles/count?_start=0&_limit=9999&_sort=published_at:DESC&_where[_and][0][_or][0][redirect_relative_url]=&_where[_and][0][_or][1][redirect_relative_url_null]=true&_where[_and][1][_or][0][noIndexNoFollow]=false&_where[_and][1][_or][1][noIndexNoFollow_null]=true`

// US Stock News API
export const apiUSStocksDetailsNewsApiUrl = (stockTickerName: string) => {
  return `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/equity/foreign-stocks/latestnews/${stockTickerName}`
}

// US Stocks Return % API
export const getUSStocksReturnPercentList = (
  commaSeparatedTickers = 'AAPL,TSLA',
) =>
  `${US_STOCKS_BASE_AUTH_URL_EXT}/v3/equity/foreign-stocks/bulkreturn?ticker=${commaSeparatedTickers}`

// US Stocks User Basic API
export const usStocksUserBasicApi = `${US_STOCKS_BASE_AUTH_URL_EXT}/v3/stocks/dw/user/account/basic`

// Wright URLs
export const getUSStocksPreMarket = `${SEO_SYSTEM_BASE_URL}/us-stocks/pre-market`
export const getUSStocksPostMarket = `${SEO_SYSTEM_BASE_URL}/us-stocks/post-market`
export const getINStocksPreMarket = `${SEO_SYSTEM_BASE_URL}/indian-stocks/pre-market`
export const getINStocksPostMarket = `${SEO_SYSTEM_BASE_URL}/indian-stocks/post-market`
export const usStocksForecastApiUrl = `${SEO_SYSTEM_BASE_URL}/us-stocks/forecast/`
export const getMFSIPCalculatorApiUrl = `${SEO_SYSTEM_BASE_URL}/mutual-funds/sip-calculators/`
export const getMFSIPExternalCalculatorApiUrl = `${SEO_SYSTEM_BASE_URL}/mutual-funds/sip-calculators/`

// Authentication flow URLs
export const getVerifyOtpUrl = `${GATEWAY_HOST}/indshield/public/ext/v6/otp/verify`
export const getLogoutUrl = `${GATEWAY_HOST}/indshield/public/auth/v1/user/logout`
export const getSendOTPUrl = `${GATEWAY_HOST}/indshield/public/ext/v2/otp/generate`
export const getSendOTPV4Url = `${GATEWAY_HOST}/indshield/public/ext/v4/otp/generate`
export const refreshTokenUrl = `${GATEWAY_HOST}/indshield/ext/v1/refresh/token`

// Payments Web API's
export const PAYMENTS_API_HOST = getPaymentsServiceUrl()

export const paymentsWebBaseUrl = getPaymentsServiceUrl()
export const paymentsWebUrlBasedOnEnv =
  process.env.STAGING_ENV === 'production'
    ? getPaymentsServiceUrl()
    : // : 'https://dev-apixt-iw.indmoney.com/payments/'
      getPaymentsServiceUrl()

export const paymentsWebWidgetsUrl = `${paymentsWebBaseUrl}api/v2/paymentflows/`

export const paymentsAddBankListOfBanksUrl = `${paymentsWebBaseUrl}api/v1/banker/user/banks/`

export const paymentsAddBankSearchBranchUrl = `${paymentsWebBaseUrl}api/v1/banker/search_branch/`

export const paymentsAddBankSearchBankUrl = `${paymentsWebBaseUrl}api/v1/banker/search_bank/`

export const paymentsAddBankBankDetailsUrl = `${paymentsWebBaseUrl}api/v1/banker/bank_details`

// Family Accounts API
export const checkFamilyAccountInvite = (invitationId: string) =>
  `${indMoneyApiBaseUrl}/v1/family/invitation/details/?invitationId=${invitationId}`

export const acceptFamilyAccountInvite = (invitationId?: string) =>
  `${indMoneyApiBaseUrl}/v1/family/invitation/accept/${invitationId}/`

// Shield API
export const SHIELD_URL = getSHIELD_URL()

// Hawkeye APIs
export const hawkeyeApiBaseUrl = 'https://apixt-in.indmoney.com/hawkeye-ext'

// Vyapar API
export const vyaparApiBaseUrl = getVyaparServiceUrl()

export const vyaparStrategyApiBaseUrl = `${GATEWAY_HOST_IN}/vyapar-strategies`

// export const vyaparApiBaseUrlPP = 'https://vyapar-pp.indiawealth.in'

export const vyaparBOApiBaseUrl = getVyaparBackgroundOfficeUrls()
export const EMAIL_REPORT_URL = `${vyaparBOApiBaseUrl}/user/initiate-queued-annual-tax-pnl-requests`

// export const vyaparBOApiBaseUrlPP = 'https://vyapar-backoffice-pp.indiawealth.in'

// IN Stocks API
export const indianStocksApiBaseUrl = getIndianStockBrokerUrl()

export const indianStocksPrivateApiBaseUrl =
  'https://apixt-in.indmoney.com/indian-stock-broker'

export const indianStocksBackgroundApiBaseUrl =
  'https://apixt-in.indmoney.com/isb-bg'
// const indianStocksApiBaseUrlPP = 'https://ind-stock-broker-pp.indiawealth.in'

export const IN_STOCKS_EXPLORE_API_URL = `${indianStocksApiBaseUrl}/catalog/explore?response_format=json`

export const IN_STOCKS_DETAILS_API_URL = `${indianStocksApiBaseUrl}/catalog/get-stock-details`

export const IN_STOCKS_INDEX_DETAILS_API_URL = `${indianStocksApiBaseUrl}/catalog/get-index-details`

export const IN_STOCKS_LISTING_API_URL = `${indianStocksApiBaseUrl}/catalog/listing`

export const IN_STOCKS_LISTING_FILTERS = `${indianStocksApiBaseUrl}/catalog/listing-filters`

export const IN_STOCKS_BG_LISTING_API_URL = `${indianStocksBackgroundApiBaseUrl}/catalog/listing`

export const IN_STOCKS_BG_LISTING_FILTERS = `${indianStocksBackgroundApiBaseUrl}/catalog/listing-filters`

export const IN_STOCKS_CHART_URL = `${indianStocksApiBaseUrl}/catalog/get-stock-graph`

export const IN_STOCKS_EXPLORE = `${indianStocksApiBaseUrl}/catalog/v2/explore`
export const IN_STOCKS_FNO_EXPLORE = `${indianStocksApiBaseUrl}/fno/catalog/explore?response_format=json`

export const IN_STOCKS_WATCHLIST_ANDOTHER_COLLECTIONS = `${indianStocksApiBaseUrl}/catalog/category-badges`

export const getWatchListCollections = ({ category }) =>
  `${IN_STOCKS_WATCHLIST_ANDOTHER_COLLECTIONS}?category_name=${category}`

export const IN_STOCKS_SALES = `/sip/sales-page/redirect`

export const IN_STOCKS_CATELOGUE = '/catalog/v2/get-entity-details/'

// US Stocks Remittance
export const transferConfigApiUrl = `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/fund-transfer-config/`
export const exchangeRateApiUrl = `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/exchange-rate/`
export const usStocksRemittanceCreateBasketId = `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/payment-transaction/`

// confirm remittance is not a screen anymore. Keeping it here for backward compatibility, or that nothing breaks.
export const getRemittanceDetailsApiUrl = (basketId: string) =>
  `${indMoneyApiBaseUrl}/v1/forex/remittance-details/?basket_id=${basketId}`
export const getConfirmRemittanceApiUrl = (basketId: string) =>
  `${indMoneyApiBaseUrl}/v1/forex/non-otp-flow/?basket_id=${basketId}`

export const manualUSRemittanceUploadGetApiUrl = `${indMoneyApiBaseUrl}/v2/user/sbm_doc/upload/config/`
export const submitITRBankStatementApiUrl = `${indMoneyApiBaseUrl}/v1/user/sbm_doc/upload/`
export const usRemittanceNextNavLinkApiUrl = `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/nav-url`
export const docUploadStatusApiUrl = `${indMoneyApiBaseUrl}/v1/user/sbm_doc/upload-status/`

// new add money config
export const getAddMoneyConfigApiUrl = (amount?: number) => {
  const baseUrl = `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/add-money-config`
  const urlObj = new URL(baseUrl)

  if (amount) {
    urlObj.searchParams.append('amount', amount.toString())
  }

  return urlObj.toString()
}

// FD APIs

export const getFDInvestmentDetailsApiUrl = (cin: string) =>
  `${FD_BASE_URL}/v1/fd/list/${cin}`

export const getFDListingsApiUrl = (memberId: number | null) =>
  `${FD_BASE_URL}/v1/fd/list${memberId ? `?member_id=${memberId}` : ''}`

export const apiGetMyFixedDeposits = (memberId: number | null) =>
  `${FD_BASE_URL}/v1/fd/web/holdings${memberId ? `?member_id=${memberId}` : ''}`

export const apiGetMyFixedDepositsCard = (memberId: number | null) =>
  `${FD_BASE_URL}/v1/fd/web/card${memberId ? `?member_id=${memberId}` : ''}`

export const apiGetBanksForFD = (leadId: string, memberId: number | null) =>
  `${FD_BASE_URL}/v1/fd/get-payment-details?lead_id=${leadId}&widget_resp=false${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const apiGetNomineeForFD = (leadId: string, memberId: number | null) =>
  `${FD_BASE_URL}/v1/fd/get-nominee-details?lead_id=${leadId}&widget_resp=false${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const apiSetBanksForFD = (leadId: string, memberId: number | null) =>
  `${FD_BASE_URL}/v1/fd/update-payment-details/${leadId}${
    memberId ? `?member_id=${memberId}` : ''
  }`

export const apiSetNomineeForFD = (leadId: string, memberId: number | null) =>
  `${FD_BASE_URL}/v1/fd/update-nominee-details/${leadId}?widget_resp=false${
    memberId ? `?member_id=${memberId}` : ''
  }`

export const apiGetFDSalesPage = (cin: string) =>
  `${FD_BASE_URL}/v1/fd/web/sales/${cin}`

export const getFDCalculationsApiUrl = (
  id: number,
  amount: number,
  pf: number,
  tenure: number,
  memberId: number | null,
) =>
  `${FD_BASE_URL}/v1/fd/catalogue/${id}/old/related/?amount=${amount}&payout_frequency=${pf}&tenure=${tenure}${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const leadInterestApiUrl = (id: number) =>
  `${FD_BASE_URL}/v1/fd/create-lead/${id}`

export const leadInterestApiUrlOld = (id: number) =>
  `${indMoneyApiBaseUrl}/v5/fd/catalogue/${id}/interest/`

export const leadDetailsApi = (lead: string, memberId: number | null) =>
  `${FD_BASE_URL}/v1/fd/lead-data/${lead}/${
    memberId ? `?member_id=${memberId}` : ''
  }`

export const leadUpdateDetailsApi = (lead: string, memberId: number | null) =>
  `${FD_BASE_URL}/v1/fd/update-lead/${lead}/${
    memberId ? `?member_id=${memberId}` : ''
  }`

export const leadDetailsApiForGet = (
  module_code: string,
  action_code: string,
  cin: string,
  step: string,
  lead: string,
  memberId: number | null,
) =>
  `${FD_BASE_URL}/v1/fd/lead-data/${lead}?module_code=${module_code}&action_code=${action_code}&cin=${cin}&step=${step}${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const leadDetailsApiOld = (lead: string, memberId: number | null) =>
  `${indMoneyApiBaseUrl}/v4/fd/leads/${lead}/${
    memberId ? `?member_id=${memberId}` : ''
  }`

export const sendFDProposalApi = `${FD_BASE_URL}/v1/fd/send-proposal`

export const leadPostApiUrl = (leadId: string) =>
  `${indMoneyApiBaseUrl}/v4/fd/leads/${leadId}/`

export const leadActionModuleCodeApiUrl = (
  leadId: string,
  module_code: string,
  action_code: string,
) =>
  `${indMoneyApiBaseUrl}/v4/fd/leads/${leadId}/?module_code=${module_code}&action_code=${action_code}`

export const leadPostPgPaymentsUrl = (leadId: string) =>
  `${indMoneyApiBaseUrl}/v2/fd/callback/ind-pg/${leadId}`

export const getFloatingApiApiUrl = (page: 'US_ADD_FUND_PAGE') =>
  `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/floating-resp?page=${page}`

export const fdOfferApiUrl = `${getFDServiceUrl()}/v1/fd/offers/`

export const hyperVergeLoginApiUrl = getHyperVergeLoginUrl()

// INDIAN STOCKS RESULTS (EARNINGS) PAGE
export const getIndianStocksResultsApiUrl = (slug: string) =>
  `${SEO_SYSTEM_BASE_URL}/indian-stocks/result/v1/${slug}`

// US STOCKS SEO EARNINGS PAGE

export type TGetUSStockEarningPageApiUrlOptions = {
  slug: string
  fields?: string[]
  summary_filter?: string
  calendar_filter?: string
  callFromClient?: boolean
  pathUrl?: 'indian-stocks' | 'us-stocks'
}

export const getUSStockEarningsPageApiUrl = (
  options: TGetUSStockEarningPageApiUrlOptions,
) => {
  const {
    slug,
    fields = ['summary', 'calendar', 'company_info', 'key_ratios', 'estimates'],
    summary_filter,
    calendar_filter,
  } = options

  const baseUrl = `${SEO_SYSTEM_BASE_URL}/us-stocks/earning/${slug}?fields=${encodeURIComponent(
    JSON.stringify(fields),
  )}`

  const urlObj = new URL(baseUrl)

  if (summary_filter) {
    urlObj.searchParams.append('summary_filter', summary_filter)
  }

  if (calendar_filter) {
    urlObj.searchParams.append('calendar_filter', calendar_filter)
  }

  return urlObj.toString()
}

export const getUSStocksTechnicalPageApiUrl = (slug: string) =>
  `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/us-stocks/technicals/${slug.toLowerCase()}`

//INSURANCE LINKS

export const getOrderDetails = (uid, oid) =>
  `${INSURANCE_BASE_URL}/v1/term-insurance/rm-proposal/get-premium/${uid}/${oid}`

export const getPaymentDetails = (uid, txn) =>
  `${INSURANCE_BASE_URL}/v2/order/payment-ops/status?txn_mapping_id=${txn}&user_id=${uid}`

// IN STOCKS SEO

type TGetINStockResultPageApiUrlOptions = {
  slug: string
  fields?: string[]
  summary_filter?: string
  calendar_filter?: string
  callFromClient?: boolean
}

export const getINStockResultsPageApiUrl = (
  options: TGetINStockResultPageApiUrlOptions,
) => {
  const { slug, summary_filter, calendar_filter } = options

  const baseUrl = `${SEO_SYSTEM_BASE_URL}/indian-stocks/result/${slug}`

  const urlObj = new URL(baseUrl)

  if (summary_filter) {
    urlObj.searchParams.append('summary_filter', summary_filter)
  }

  if (calendar_filter) {
    urlObj.searchParams.append('calendar_filter', calendar_filter)
  }
  return urlObj.toString()
}

type TGetStockDividendsPageApiUrlOptions = {
  slug: string
  summary_filter?: string
  calendar_filter?: string
  pathUrl?: string
  callFromClient?: boolean
}
export const getStocksDividendsPageApiUrl = (
  options: TGetStockDividendsPageApiUrlOptions,
) => {
  const {
    slug,
    summary_filter,
    calendar_filter,
    pathUrl = 'us-stocks',
  } = options

  const baseUrl = `${SEO_SYSTEM_BASE_URL}/${pathUrl}/dividend/${slug}`

  const urlObj = new URL(baseUrl)

  if (summary_filter) {
    urlObj.searchParams.append('summary_filter', summary_filter)
  }

  if (calendar_filter) {
    urlObj.searchParams.append('calendar_filter', calendar_filter)
  }

  return urlObj.toString()
}

export const getMFCompareSearchApiUrl = (inputValue?: string) => {
  const baseUrl = `${SEO_SYSTEM_BASE_URL}/mutual-funds/search`
  const urlObj = new URL(baseUrl)

  if (inputValue) {
    urlObj.searchParams.append('query', inputValue)
  }

  return urlObj.toString()
}

export const getMFCompareMainDataUrl = ({
  slug,
  queryParams = {},
}: {
  slug?: string
  queryParams?: {
    only_chart_data?: boolean
    chart_interval?: string
  }
} = {}) => {
  const baseUrl = `${MF_BASE_URL}/v1/seo/pages/compare`
  const urlObj = new URL(baseUrl)

  if (slug) {
    urlObj.pathname = `${urlObj.pathname}/${slug}`
  }

  Object.keys(queryParams).forEach(queryKey => {
    if (queryParams[queryKey]) {
      urlObj.searchParams.append(queryKey, queryParams[queryKey])
    }
  })

  return urlObj.toString()
}

export const getMFNavAPIUrl = ({
  slug,
  queryParams = {},
  initiator = 'server',
}: {
  slug?: string
  queryParams?: {
    only_chart_data?: boolean
    chart_interval?: string
  }
  initiator?: 'server' | 'client'
} = {}) => {
  const baseUrl = `${
    initiator === 'server' ? SEO_SYSTEM_BASE_URL : SEO_SYSTEM_BASE_URL
  }/mutual-funds/nav`
  const urlObj = new URL(baseUrl)

  if (slug) {
    urlObj.pathname = `${urlObj.pathname}/${slug}`
  }

  Object.keys(queryParams).forEach(queryKey => {
    if (queryParams[queryKey]) {
      urlObj.searchParams.append(queryKey, queryParams[queryKey])
    }
  })

  return urlObj.toString()
}

export const getMutualFundDetailsFAQUrl = (
  mutualFundId: number,
  initiator: 'server' | 'client' = 'server',
) => {
  const baseUrl =
    initiator === 'server' ? SEO_SYSTEM_BASE_URL : SEO_SYSTEM_BASE_URL

  return `${baseUrl}/mutual-funds/faqs/${mutualFundId}`
}

export const getMFAmcWrightApiUrl = (amcSlug: string) => {
  return `${SEO_SYSTEM_BASE_URL}/mutual-funds/amc/${amcSlug}`
}

export const getUSTrendingStocksAPIUrl = (
  initiator: 'server' | 'client' = 'server',
) => {
  const baseUrl =
    initiator === 'server' ? US_STOCKS_BASE_URL : US_STOCKS_BASE_AUTH_URL_EXT

  return `${baseUrl}/trending-stocks-template/`
}

export const getUSPortfolioSummaryApiUrl = (
  initiator: 'server' | 'client' = 'server',
) => {
  const baseUrl =
    initiator === 'server'
      ? US_STOCKS_BASE_AUTH_URL
      : US_STOCKS_BASE_AUTH_URL_EXT

  return `${baseUrl}/v1/usstocks/widget/us-stocks/dashboard/masthead`
}

export const getNewUSStocksExplorePageApi = (tokenPresent?: boolean) => {
  // different api route for different url, a limitation from how us stocks BE architecture has been designed
  // i.e. they have different auth and non auth apis
  if (tokenPresent) {
    return `${US_STOCKS_BASE_AUTH_URL_EXT}/v3/explore-web/`
  } else {
    return `${US_STOCKS_BASE_AUTH_URL_EXT}/v3/logged-out/explore-web/`
  }
}

export const getWatchListAndOtherCollectionsAPI = (
  category?: string,
  tokenPresent?: boolean,
) => {
  let baseUrl = ''

  // different api route for different url, a limitation from how us stocks BE architecture has been designed
  // i.e. they have different auth and non auth apis
  if (tokenPresent) {
    baseUrl = `${US_STOCKS_BASE_AUTH_URL_EXT}/v3/more-section-web/`
  } else {
    baseUrl = `${US_STOCKS_BASE_AUTH_URL_EXT}/v3/logged-out/more-section-web/`
  }

  const urlObj = new URL(baseUrl)

  if (category) {
    urlObj.searchParams.append('category', category)
  }

  return urlObj.toString()
}

export const getNewUsStocksCatalogueApiUrl = (
  category: string,
  subCategory?: string,
) => {
  const baseUrl = `${US_STOCKS_BASE_AUTH_URL_EXT}/v3/catalog-web/${category}`
  const urlObj = new URL(baseUrl)

  if (subCategory) {
    urlObj.searchParams.append('subCategory', subCategory)
  }

  return urlObj.toString()
}

// ------------------ KYC 2.0 ------------------------------ //
// ''
const KYC2_API_HOST = 'https://apixt-iw.indmoney.com/ingress'

export const getJourneyNavlinkApiUrl = ({
  flowType,
  member_id,
  isInMobile,
}: {
  flowType: string
  member_id?: null | string
  isInMobile?: boolean
}) => {
  const platformType = getPlatformType(isInMobile)
  return `${KYC2_API_HOST}/api/v1/kyc/journey/?flowType=${flowType}${
    member_id ? `&member_id=${member_id}` : ''
  }${isInMobile ? `&platform=${platformType}` : ''}`
}

export const getKycFlowConfigApiUrl = ({
  flowType,
  page = 'KYC_FLOW',
  member_id,
  basketId,
}: {
  flowType: string
  page: string
  member_id?: null | string
  basketId?: string
}) =>
  `${KYC2_API_HOST}/api/v5/kyc/flowStepConfig/?&platform=web&page=${page}&flowType=${flowType}${
    member_id ? `&member_id=${member_id}` : ''
  }${basketId ? `&basketId=${basketId}` : ''}`

export const getKycFlowEmailVerifyApiUrl = ({
  flowType,
}: {
  flowType: string
}) =>
  `${KYC2_API_HOST}/api/v1/kyc/emailVerificationConfig/?flowType=${flowType}`

export const usStocksScreenerAPIUrl = `${US_STOCKS_BASE_AUTH_URL_EXT}/equity/foreign-stocks/screener?get_filters=true`

export const getMyStocksAPIUrl = (
  page: number = 1,
  limit: number = myUSStockPaginationLimit,
) =>
  `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/stocks/dw/user/account/holdings/?page=${page}&limit=${limit}`

// Dashboardv2 APIs

export const getDashboardConfigApi = ({
  memberId,
}: {
  memberId?: null | number
}) =>
  `${OCTOPUS_BASE_URL}/v2/users/page/dashboard${
    memberId ? `?member_id=${memberId}` : ''
  }`

export const getWidgetDataApi = ({
  memberId,
  widgetId,
}: {
  widgetId: number
  memberId?: null | number
}) =>
  `${WIDGET_BASE_URL}/user/get-widget/?widgetId=${widgetId}&platform=web${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const apiGetLinkedBAconfig = (
  flow_type: string,
  memberId: number | string | null,
) =>
  `${paymentsWebBaseUrl}api/v1/banker/accounts?flow_type=${flow_type}${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const apiGetLinkedINDstocksBAconfig = (
  memberId: number | string | null,
) =>
  `${VYAPER_HOST}/user/get-bank-accounts${
    memberId ? `?member_id=${memberId}` : ''
  }`

export const apiGetIndStocksNomineeDetails = (
  memberId: number | string | null,
) =>
  `${VYAPER_HOST}/user/nominee/details${
    memberId ? `?member_id=${memberId}` : ''
  }`

export const apiGetNomineeCenterWidgetDetails = memberId =>
  `${IND_MEMORY_EXT_WEALTH_BASE_URL}/api/v1/widget/nominee_center${
    memberId ? `?member_id=${memberId}` : ''
  }`

export const apiGetMFCenterPollWidgetDetails = (otp, flowType, memberId) =>
  `${MF_BASE_URL}/v2/tracking/ecas/mf-central-poll?otp_id=${otp}${
    flowType ? `&flowType=${flowType}` : ''
  }${memberId ? `&member_id=${memberId}` : ''}`

export const apiGetNomineeInvestmentBreakupWidgetDetails = (
  been_nominated,
  first_name,
  last_name,
  nominee_user_id,
  relation,
  memberId,
) =>
  `${IND_MEMORY_EXT_WEALTH_BASE_URL}/api/v1/widget/nominee_investment_breakup?been_nominated=${been_nominated}${
    first_name ? `&first_name=${first_name}` : ''
  }${last_name ? `&last_name=${last_name}` : ''}${
    nominee_user_id ? `&nominee_user_id=${nominee_user_id}` : ''
  }${relation ? `&relation=${relation}` : ''}${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const apiGetCreditCardPaymentWidgetDetails = (
  queryParams: Record<string, string>,
) => {
  if (process.env.STAGING_ENV === 'production') {
    queryParams.fe_env = 'prod'
  } else {
    queryParams.fe_env = 'beta'
  }
  let apiEndpoint = 'api/v1/card'
  if (queryParams.page === 'creditCardPaymentEntry') {
    apiEndpoint = 'api/v1/card/entry-point'
  } else if (queryParams.page === 'creditCardPaymentExit') {
    apiEndpoint = 'api/v1/card/exit'
  }
  const url = new URL(`${paymentsWebUrlBasedOnEnv}${apiEndpoint}`)
  Object.keys(queryParams).forEach(key => {
    url.searchParams.set(key, queryParams[key])
  })
  return url.toString()
}

//  Calculator APIs
export const incomeTaxPostApiUrl = `${MF_BASE_URL}/seo/v1/tax/calculator/`
export const getIncomeTaxFormApiUrl = `${MF_BASE_URL}/seo/v1/tax/page/`
export const getIncomeTaxFormApiUrlV2 = `${IND_MEMORY_EXT_WEALTH_BASE_URL}/public/v1/tax/page`
export const incomeTaxPostApiUrlV2 = `${IND_MEMORY_EXT_WEALTH_BASE_URL}/public/v1/tax/calculator`
export const getIncomeTaxStaticApiUrl = `${MF_BASE_URL}/seo/v1/tax/static/`

export const getAmcApiUrl = (slug: string) =>
  `${MF_BASE_URL}/seo/v1/amc/${slug}`
export const getAmcStaticApiUrl = (slug: string) =>
  `${MF_BASE_URL}/seo/v1/amc/${slug}/static`

//  Saving Account Expense APIs

export const viewAllTransactionsApiUrl = ({
  account_number,
  account_id,
  bank_name,
  type,
  request_type,
  txn_ids,
}: {
  account_number?: string | string[]
  account_id?: string | string[]
  bank_name?: string | string[]
  type?: string | string[]
  request_type?: string | string[]
  txn_ids?: string | string[]
}) =>
  `${ACCOUNT_AGGREGATOR_BASE_URL}/api/v1/aggregator/view-all-transactions/?account_number=${account_number}&account_id=${account_id}&bank_name=${bank_name}&type=${type}${
    request_type ? `&request_type=${request_type}` : ''
  }${txn_ids ? `&txn_ids=${txn_ids}` : ''}`

export const savingAccountExpenseL2PageApiUrl = ({
  account_number,
  account_id,
  type,
  source,
  page,
}: {
  account_number?: string | string[]
  account_id?: string | string[]
  type?: string | string[]
  source?: string | string[]
  page?: string | string[]
}) =>
  `${ACCOUNT_AGGREGATOR_BASE_URL}/api/v1/aggregator/l2-screen/?account_number=${account_number}&account_id=${account_id}&page=${page}&source=${source}&type=${type}`

export const allSavingAccountsDetailApiUrl = ({
  page,
  source,
  deleteAccount,
}: {
  page?: string | string[]
  deleteAccount: string | string[] | null
  source: string | string[] | null
}) =>
  `${ACCOUNT_AGGREGATOR_BASE_URL}/api/v1/aggregator/l1-screen/?platform=web&page=${page}${
    source ? `&source=${source}` : ''
  }${deleteAccount ? `&delete=${deleteAccount}` : ''}`

// Other Investments APIs
export const addCashFlowBottomSheetApiUrl = ({
  page,
  action_type,
  type,
  holding_id,
  transaction_id,
  memberId,
}: {
  page?: string | string[]
  action_type?: string | string[]
  type?: string | string[]
  holding_id?: string | string[]
  transaction_id?: string | string[]
  memberId: number | null
}) =>
  `${indTrackApiBaseUrl}/v2/other-investments/cash-flow-details-bottom-widget?action_type=${action_type}&page=${page}&type=${type}&holding_id=${holding_id}&${
    transaction_id ? `transaction_id=${transaction_id}&` : ''
  }${memberId ? `member_id=${memberId}` : ''}`

export const addCashflowPageApiUrl = ({
  page,
  holding_id,
  memberId,
}: {
  page?: string | string[]
  holding_id?: string | string[]
  memberId: number | null
}) =>
  `${indTrackApiBaseUrl}/v2/other-investments/cash-flow-details-widget?page=${page}&holding_id=${holding_id}${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const addInvestmentDetailApiUrl = ({
  page,
  instrument_type,
  holding_id,
  listed_unlisted,
  currency,
  memberId,
}: {
  page?: string | string[]
  instrument_type?: string | string[]
  listed_unlisted?: string | string[]
  holding_id?: string | string[]
  currency?: string | string[]
  memberId: number | null
}) =>
  `${indTrackApiBaseUrl}/v2/other-investments/investment-details-widget?page=${page}&instrument_type=${instrument_type}&${
    holding_id ? `holding_id=${holding_id}&` : ''
  }${listed_unlisted ? `listed_unlisted=${listed_unlisted}&` : ''}${
    currency ? `currency=${currency}&` : ''
  }${memberId ? `member_id=${memberId}` : ''}`

export const addTransactionBottomSheetApiUrl = ({
  page,
  holding_id,
  action_type,
  transaction_id,
  memberId,
}: {
  page?: string | string[]
  action_type?: string | string[]
  holding_id?: string | string[]
  transaction_id?: string | string[]
  memberId: number | null
}) =>
  `${indTrackApiBaseUrl}/v2/other-investments/transaction-bottom-widget?${
    transaction_id ? `transaction_id=${transaction_id}&` : ''
  }action_type=${action_type}&page=${page}&holding_id=${holding_id}${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const addTransactionPageApiUrl = ({
  page,
  holding_id,
  memberId,
}: {
  page?: string | string[]
  holding_id?: string | string[]
  memberId: number | null
}) =>
  `${indTrackApiBaseUrl}/v2/other-investments/transaction-details-widget?page=${page}&holding_id=${holding_id}${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const esopsBottomSheetApiUrl = ({
  page,
  memberId,
}: {
  page?: string | string[]
  memberId: number | null
}) =>
  `${indTrackApiBaseUrl}/v2/other-investments/esops-bottom-widget?page=${page}${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const investmentAddedPageApiUrl = ({
  page,
  holding_id,
  memberId,
}: {
  page?: string | string[]
  holding_id?: string | string[]
  memberId: number | null
}) =>
  `${indTrackApiBaseUrl}/v2/other-investments/success-widget?page=${page}&holding_id=${holding_id}${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const investmentOptionSheetApiUrl = ({
  page,
  holding_id,
  memberId,
}: {
  page?: string | string[]
  holding_id?: string | string[]
  memberId: number | null
}) =>
  `${indTrackApiBaseUrl}/v2/other-investments/mini-app-bottom-widget?page=${page}&holding_id=${holding_id}${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const otherInvestmentsApiUrl = ({
  page,
  memberId,
}: {
  page?: string | string[]
  memberId: number | null
}) =>
  `${indTrackApiBaseUrl}/v2/other-investments/instrument-widget?page=${page}${
    memberId ? `&member_id=${memberId}` : ''
  }`

export const v1OiMiniAppApiUrl = ({
  pagename,
  instrument_type,
  memberId,
}: {
  pagename?: string | string[]
  instrument_type?: string | string[]
  memberId: number | null
}) =>
  `${indTrackApiBaseUrl}/v2/other-investments/mini-app-widget?pageName=${pagename}&instrument_type=${instrument_type}${
    memberId ? `&member_id=${memberId}` : ''
  }`

// REPORTS API

export const mfTaxProfileCGApiUrl = `${MF_BASE_URL}/v1/static/capital-gains-screen`
export const taxProfileApiUrl = `${SHIELD_BASE_URL}/widget/api/v1/page-details`
export const usTaxProfileApiUrl = `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/us-stocks/tax-docs/summary`
export const usTaxDownlaodApiUrl = `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/us-stocks/tax-docs/download`
export const mfElssReportUrl = `${MF_BASE_URL}/v1/static/elss-screen`
export const portfolioReportUrl = `${IND_MEMORY_EXT_BASE_URL}/api/v1/widget/portfolio_reports_page`
export const reportsDetailPageUrl = `${IND_MEMORY_EXT_BASE_URL}/api/v1/widget/reports_page`
export const dividendReportsApiUrl = `${VYAPER_HOST}/static/dividend-screen`

// PNL API

export const pnlDataUrl = `${VYAPER_HOST}/pnl/data`
export const pnlBottomsheetDataUrl = `${VYAPER_HOST}/pnl/data/trade-level`

// IPO APIs

export const ipoCenterUrl = `${VYAPER_HOST}/ipo/`
export const ordersIpoCenterUrl = `${VYAPER_HOST}/ipo/order/history`
export const myIpoCenterUrl = `${VYAPER_HOST}/ipo/allotted`
export const ipoDetailsUrl = (id: string) => `${VYAPER_HOST}/ipo/${id}/details`
export const ipoDetailsUrlV2 = `${VYAPER_HOST}/ipo/v2/details`
export const summaryIpoCenterUrl = `${VYAPER_HOST}/ipo/summary`
export const ipoStatusUrl = () => `${VYAPER_HOST}/ipo/v2/order/status`
export const IPO_CENTER_PAYMENT_OPTIONS = `${VYAPER_HOST}/ipo/payment/options`
export const IPO_CENTER_ORDER = `${VYAPER_HOST}/ipo/order/create`
export const IPO_CENTER_CANCEL_ORDER = `${VYAPER_HOST}/ipo/order/cancel`
export const IPO_SITEMAP_API_URL = `https://apixt-in.indmoney.com/vyapar-backoffice/ipo/sitemap`

// STRAPI APIs

export const strapiIndexApi = slug =>
  `${strapi4BaseURL}/indian-stocks/index${SLASH_OPERATOR}${slug}`
export const strapiStocksCategoryApi = slug =>
  `${strapi4BaseURL}/indian-stocks/category${SLASH_OPERATOR}${slug}`
export const getStrapi4CalculatorApiUrl = (slug: string) =>
  `${strapi4BaseURL}/calculators/${slug}`
export const strapiFnOApi = `${strapi4BaseURL}/fnos/futures-and-options`
export const strapiIndiciesDetailApi = `${strapi4BaseURL}/indian-stocks/indices`
export const strapiOptionChainUrl = (slug: string) =>
  `${strapi4BaseURL}/fnos/options-chain${SLASH_OPERATOR}${slug}`
export const strapiIPOApi = (slug: string) => `${strapi4BaseURL}/ipos/${slug}`
export const strapiUSstocksApi = `${strapi4BaseURL}/us-stocks/us-stock`
export const strapiStocksOpenDematApi = `${strapi4BaseURL}/indian-stocks/open-demat-account`
export const strapiUSstocksL2Api = (ticker: string) =>
  `${strapi4BaseURL}/us-stocks/${ticker}`
export const strapiINstocksApi = (slug: string) =>
  `${strapi4BaseURL}/indian-stocks/${slug}`
export const strapiMFL1Api = (mfCategory: string, mfSubCategory?: string) =>
  `${strapi4BaseURL}/mutual-funds/${mfCategory}${
    mfSubCategory ? `${SLASH_OPERATOR}${mfSubCategory}` : ''
  }`

export const mutualFundsCategoryUrl = `${MF_BASE_URL}/v1/seo/widgets/l0-page?widget_name=asset_class_by_cg`

// Market APIs

export const getMarketNewsUrl = (slug: string) =>
  `${SEO_SYSTEM_BASE_URL}/web/v1/markets/${slug}`

export const getAuthorDetailsUrl = (slug: string) =>
  `${strapiBaseURL}/article-author/${slug}`

export const getAuthorArticlesUrl = (slug: string, page: number) =>
  `/api/articles-author?page=${page}&limit=5&slug=${slug}`

export const allAuthorsUrl = `${strapiBaseURL}/article-all-meta-authors`

// SITEMAP APIs

export const usTechnicalsSitemapApi = `${US_STOCKS_BASE_AUTH_URL_EXT}/v1/seo/technicals/meta/info`

export const mfCategoriesUrl = `${MF_BASE_URL}/v1/seo/widgets/l0-page?widget_name=top_funds_category_v2`
export const allAmcBaseUrl = `${MF_BASE_URL}/v1/seo/widgets/l1-page`
export const allAMCUrl = `${allAmcBaseUrl}?widget_name=all_amc_widget&sort=name&source=amc`
export const allAMCUrlSortAum = `${allAmcBaseUrl}?widget_name=all_amc_widget&source=amc&sort=aum&limit=100`

export const getFilteredArticlesUrl = ({
  start = 0,
  limit = -1,
  preSlugPath,
}: {
  start?: number
  limit?: number
  preSlugPath?: string
}) => {
  return `${strapiBaseURL}/articles?${
    preSlugPath ? `_where[preSlugPath.preSlugPath]=${preSlugPath}&` : ''
  }_start=${start}&_limit=${limit}&_sort=published_at:DESC&_where[_and][0][_or][0][redirect_relative_url]=&_where[_and][0][_or][1][redirect_relative_url_null]=true&_where[_and][1][_or][0][noIndexNoFollow]=false&_where[_and][1][_or][1][noIndexNoFollow_null]=true`
}

export const amcSitemapApi = `${MF_BASE_URL}/v1/amcs/`

export const mfCompareSitemapApi = `${MF_TRACKING_BASE_URL}/v1/sitemap/compare?sitemap=true`
